import { render, staticRenderFns } from "./TrialBanner.vue?vue&type=template&id=224205f3&scoped=true"
import script from "./TrialBanner.vue?vue&type=script&lang=js"
export * from "./TrialBanner.vue?vue&type=script&lang=js"
import style0 from "./TrialBanner.vue?vue&type=style&index=0&id=224205f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224205f3",
  null
  
)

export default component.exports